const $$splitComponentImporter = () => import('/app/src/routes/dashboard/therapist/therapies.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
type StatusFilter = "" | "scheduled" | "completed" | "cancelled";
function isStatusFilter(value: unknown): value is Exclude<StatusFilter, ""> {
  return value === "scheduled" || value === "completed" || value === "cancelled";
}
export const Route = createFileRoute("/dashboard/therapist/therapies")({
  validateSearch: (search: Record<string, unknown>): {
    status?: Exclude<StatusFilter, "">;
  } => isStatusFilter(search.status) ? {
    status: search.status
  } : {},
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});